import { combineReducers } from 'redux'

import main from './MainState'

export default combineReducers({
  main
})
